module.exports = __webpack_public_path__ + "img/gitterpommes.f8eefdd4.jpg";